
/**
 * @param {object} state Estado
 * @param {object} action Accion
 * @returns {void} Retorna un nuevo estado
 */
export default function QueryContratoReducer(state, action) {
    // const estadoTemp = {...state,domain:{...state.domain},};
    // estadoTemp.domain.cargado={};
    const nuevoEstado = JSON.parse(JSON.stringify(state));
    return action.ejecutar(state, nuevoEstado);
}
